export const TypesHightPhoto = {
    default: "default",
    mascota: "mascota",
    cartilla: "cartilla",
    noImageMascota: "noImgMascota",
}

export const MESSAGE_SMALL = {
    title_modal: "Enviar datos",
    paragrahp1: "Está a punto de enviar la cartilla de vacunación de tu mascota",
    paragrahp2: "¿Desea continuar?",
    paragrahp3: "Declaro la veracidad de los datos proporcionados.",
  };

export const MESSAGE_MEDIUM = {
    title_modal: "La información fue enviada exitosamente",
    paragrahp1:
      "Está a punto de enviar la cartilla de vacunación de tu mascota Está a punto de enviar la cartilla de vacunación de tu mascota Está a punto de enviar la cartilla de vacunación de tu mascota Está a punto de enviar la cartilla de vacunación de tu mascota",
  };

export const MESSAGE_LARGE = {
    title_modal: "Actualizar foto de perfil",
    paragrahp1: "Archivo seleccionado foto.jpeg",
    paragrahp2:
      'Para recortar la imagen arrastra el area siguiente y haz click en "actualizar"',
    paragrahp3: "arrastre una foto aquí",
    paragrahp4: "Selecciona una foto",
  };

export const replaceErrorOnMascota = {
  "infoMascota":{
     "tipo":"-------",
     "nombre":"-------",
     "raza":"-------",
     "edad":"-------"
  },
  "links_mascota":[
     {
        "id":"frontal",
        "nombre":"frontal",
        "tipo":"link",
        "url":""
     },
     {
        "id":"trasera",
        "nombre":"trasera",
        "tipo":"link",
        "url":""
     },
     {
        "id":"lateralizquierda",
        "nombre":"lateralizquierda",
        "tipo":"link",
        "url":""
     },
     {
        "id":"lateralderecha",
        "nombre":"lateralderecha",
        "tipo":"link",
        "url":""
     }
  ],
  "links_cartilla":[
     {
        "id":"cartilla",
        "nombre":"cartilla",
        "tipo":"link",
        "url":""
     }
  ]
};
export const Producto_Comercial = {
   mascota1: "MI MASCOTA GNP",
   mascota2: "MASCOTA PROTEG. GNP"
}
export const Id_Producto_Backend = {
   SINIESTRO: {
      lebel: 'siniestro-mascotas',
      id: 4
   },
   SEGUIMIENTO: {
      lebel: 'seguimiento-mascota',
      id: 5
   },
   HISTORIAL: {
      lebel: 'historial-mascota',
      id: 6
   }
}


// WEBPACK FOOTER //
// ./src/constants/constants.js